import { type Dispatch } from 'react';
import { match } from 'ts-pattern';

import { type Money } from '../../../shared/price';
import {
    trackCountDropdownClicked,
    trackDropdownSelection,
} from '../../components/AppointmentSelector/AppointmentSelector.tracking';
import { dispatchEvent } from '../../helper/EventUtils';
import { eventTypes } from '../../types';
import { type BuyboxReducerAction } from '../../types/buyboxReducerTypes';
import { type PurchaseType } from '../../types/enums/purchaseType';
import { BuyboxReducerActionType } from '../../types/enums/reducer/buyboxReducerAction';

const dispatchPurchaseType = (
    dispatch: Dispatch<BuyboxReducerAction>,
    value: PurchaseType,
): void => {
    dispatch({
        type: BuyboxReducerActionType.PurchaseType,
        value: { purchaseType: value },
    });
    dispatchEvent(eventTypes.PURCHASE_TYPE_CHANGE, { purchaseType: value });
};

const dispatchSeatCountChange = async (
    dispatch: Dispatch<BuyboxReducerAction>,
    selectedSeatCount: string,
    title: string,
    seatCount?: string,
    trackSelection = false,
): Promise<void> => {
    dispatch({
        type: BuyboxReducerActionType.SeatCount,
        value: { seatCount: selectedSeatCount },
    });

    if (trackSelection) {
        if (seatCount || Number(selectedSeatCount) > 1) {
            await trackDropdownSelection(title, Number(selectedSeatCount) - Number(seatCount || 1));
        }
    } else {
        trackCountDropdownClicked();
    }
};

const dispatchResetErrors = (dispatch: Dispatch<BuyboxReducerAction>): void => {
    dispatch({ type: BuyboxReducerActionType.ResetErrors });
};

const dispatchValueVoucherPriceChange = (
    dispatch: Dispatch<BuyboxReducerAction>,
    valueVoucherPrice: Money,
): void => {
    dispatch({
        type: BuyboxReducerActionType.ValueVoucherPriceChange,
        value: { valueVoucherPrice },
    });
};

const handleErrorByCode = (dispatch: Dispatch<BuyboxReducerAction>, errorCode?: number): void => {
    match(errorCode)
        .with(102, () => {
            dispatch({ type: BuyboxReducerActionType.MixedShoppingCartError });
        })
        .with(1_101, () => {
            dispatch({ type: BuyboxReducerActionType.AddingMultipleItemsNotAllowedError });
        })
        .otherwise(() => {
            dispatch({ type: BuyboxReducerActionType.AddToCartError });
        });
};

export {
    dispatchPurchaseType,
    dispatchResetErrors,
    dispatchSeatCountChange,
    dispatchValueVoucherPriceChange,
    handleErrorByCode,
};
